export const formatDate = (date) => {
  return date.toISOString().split("T")[0];
};

export const getSixtyDaysAgo = () => {
  let date = new Date();
  date.setDate(date.getDate() - 61);
  return date;
};
